// 简体中文语言包
export const zhCN = {
  brand: { name: 'Escalote', full: '紧急事件通知升级系统', tagline: '消息 · 超时 · 电话叫醒 · 逐级升级' },
  common: {
    save: '保存', cancel: '取消', confirm: '确认', create: '新建', edit: '编辑', delete: '删除', deleted: '已删除',
    crash: '页面渲染出错', backHome: '回指挥台', retry: '重试本页面', on: '开', off: '关',
    close: '关闭', search: '搜索', reset: '重置', all: '全部', loading: '加载中…', actions: '操作',
    status: '状态', severity: '级别', title: '标题', description: '描述', language: '语言',
    timezone: '时区', logout: '退出登录', refresh: '刷新', copy: '复制', copied: '已复制',
    required: '必填', optional: '选填', system: '系统', name: '姓名', phone: '电话', email: '邮箱', role: '角色',
    position: '顺序', customer: '客户', service: '服务', category: '问题类型', keyword: '关键字', source: '来源',
    createdAt: '登记时间', resolvedAt: '解决时间', closedAt: '关闭时间', ackAt: '首次响应',
    readAt: '首次已读', note: '批注', total: '共 {{count}} 条', minutesUnit: '分钟', timesUnit: '次',
    back: '返回', view: '查看', enabled: '启用', disabled: '停用', yes: '是', no: '否', none: '无',
    operator: '当前操作人', lastActive: '最近心跳',
    range: { d7: '近 7 天', d14: '近 14 天', d30: '近 30 天', d90: '近 90 天', all: '不限' },
    error: {
      GENERIC: '操作失败，请重试', NETWORK: '网络错误，无法连接服务器',
      BAD_CREDENTIALS: '账号或密码错误', UNAUTHORIZED: '登录已过期，请重新登录',
      NOTE_REQUIRED: '请填写批注说明', INVALID_TRANSITION: '不允许的状态流转',
      SAME_STATUS: '事件已处于该状态', SCOPE_DENIED: '无权访问该服务',
      RATE_LIMITED: '尝试次数过多，请稍后再试', FORBIDDEN: '权限不足',
      NO_WECOM_USER: '该企业微信账号未在系统中登记，请联系管理员',
      WECOM_AUTH_FAILED: '企业微信授权失败，请重试', LINK_EXPIRED: '链接已过期，请重新登录',
      INVALID_API_KEY: '服务代码或 API Key 无效', USER_DISABLED: '账号已被停用',
    },
  },
  nav: {
    dashboard: '指挥台', events: '事件中心', services: '服务目录', customers: '客户管理',
    categories: '问题类型', users: '用户与权限', audit: '审计日志', settings: '系统设置',
    mobileHub: '移动端演练',
  },
  auth: {
    signIn: '登录指挥台', signBtn: '登 录', username: '账号', password: '密码',
    tabPassword: '账号密码', tabQr: '微信扫码登录', autoSignIn: '企业微信一键登录',
    qrHint: '使用企业微信或已绑定的个人微信扫描二维码；首次使用需管理员在企微后台配置可信域名',
    err: {
      WECOM_AUTH_FAILED: '企业微信授权失败，请重试或使用账号密码登录',
      NO_WECOM_USER: '您的企业微信账号尚未在本系统建档，请联系管理员开通',
    },
    mockTitle: '企业微信身份模拟（演示）', mockHint: '点击下方身份即可免密登录，模拟值班人员收到告警后的处理过程',
    signing: '登录中…', poweredBy: '基于企业微信 · 支持中/繁/英与多时区协作',
  },
  status: { open: '待处理', acknowledged: '已响应', in_progress: '处理中', resolved: '已解决', closed: '已关闭', cancelled: '已取消' },
  severity: { P1: 'P1 · 危急', P2: 'P2 · 严重', P3: 'P3 · 一般' },
  tier: { t1: '一线值班', t2: '二线值班', t3: '管理层', chain: '升级层级', endedShort: '已终止' },
  source: { api: 'API 上报', manual: '人工建单' },
  dashboard: {
    hello: '指挥台总览', window: '时间窗口', filters: '筛选',
    kpi: {
      total: '事件总数', active: '处理中事件', p1: 'P1 危急事件', unacked: '无人响应',
      ackRate: '响应覆盖率', avgResp: '平均首次响应', avgResolve: '平均解决时长',
    },
    trend: '事件趋势（按登记日·查看时区）', dimCustomer: '按客户统计', dimService: '按服务统计', dimCategory: '按问题类型统计',
    dimPerson: '人员处理统计', colCount: '事件数', colActive: '未结案', colAvgResp: '平均首响', colAvgResolve: '平均解决',
    person: { ackCount: '响应次数', resolvedCount: '解决次数', notified: '被通知数' },
    top: {
      title: 'Top 10 时效榜', kindResponse: '首次响应', kindResolve: '处理时长',
      best: '最快 Top10', worst: '最慢 Top10', empty: '暂无符合条件的事件',
    },
    empty: '该时间窗口内没有事件数据',
  },
  events: {
    listTitle: '事件中心', newEvent: '手工建单', mine: '我值班的', uuid: '事件 UUID',
    filterStatus: '状态', filterSeverity: '级别', filterService: '服务', filterCustomer: '客户', filterCategory: '类型',
    colRaised: '登记时间', colFirstResp: '首响', colResolution: '解决时长', colTier: '升级层级', colAckUser: '响应人',
    detailTitle: '事件详情', basic: '基本信息', timeline: '处理时间线', notes: '通知与呼叫记录',
    roster: '值班配置', noRoster: '该服务暂未配置值班人员',
    act: {
      ack: '确认接单', start: '开始处理', resolve: '标记解决', close: '关闭事件', cancel: '误报取消', reopen: '重新打开',
      ackNotePh: '说明你正在接手处理（必填）', in_progressNotePh: '说明开始处理的内容（必填）',
      resolveNotePh: '说明根因与处理结果（必填）', closeNotePh: '确认闭环的说明（必填）',
      cancelNotePh: '说明误报判定原因（必填）',
    },
    modalAckTitle: '确认接单', modalStatusTitle: '状态流转 · {{to}}',
    escalationBanner: {
      tier1: '已通知一线值班，等待确认', tier2: '一线超时未响应 — 已升级二线', tier3: '一/二线均未响应 — 已电话轮呼管理员',
      done: '升级链已终止（已有人响应或事件结束）', waiting: '升级引擎监控中',
    },
    demoLink: '模拟点击企微卡片（免密跳转演练）', reboost: '重新引导通知（超管）',
    notifyCols: { target: '接收人', channel: '渠道', lang: '语言', result: '结果', sentAt: '发送时间' },
    channel: { wecom_textcard: '企微卡片', wecom_markdown: '企微消息', voice_call: '语音电话' },
    notifStatus: { sent: '已送达', pending: '发送中', failed: '失败', read: '已读', cancelled: '已取消', answered: '已接听', no_answer: '未接听' },
    call: { answered: '已接听', missed: '未接听', dialing: '拨打中', inCall: '通话中', dialFailed: '呼叫失败' },
    createTitle: '手工登记紧急事件', createOk: '事件已登记，升级链已启动',
    deleteConfirm: '删除该事件？将连同时间线、通知、任务、呼叫记录一并彻底删除，不可恢复',
    batchDeleteConfirm: '确认删除选中的 {count} 条事件？将连同其全部关联记录彻底删除，不可恢复',
    deleteSelected: '删除选中', deletedN: '已删除 {count} 条事件',
  },
  timeline: {
    create: '事件登记', notified: '已通知值班', read: '消息已读', acknowledged: '确认响应',
    in_progress: '开始处理', resolved: '问题解决', closed: '事件关闭', cancelled: '误报取消',
    escalate: '升级通知', escalate_pending: '超时升级', voice_call: '语音呼叫',
    no_assignee: '层级无人值班', voice_exhausted: '语音重试已用尽',
    admin_rotation_start: '管理员电话轮呼开始', admin_rotation_exhausted: '轮呼达上限仍无人响应',
    voice_stopped: '接听即停轮呼',
  },
  services: {
    title: '服务目录', code: '服务代码', name: '服务名称', desc: '说明', apiKeyHint: 'Key 前缀',
    create: '新建服务', createOk: '服务创建成功', detail: '服务配置',
    keyOnceTitle: '请立即保存 API Key', keyOnceBody: '出于安全考虑，系统只展示一次明文。丢失请轮换。',
    rotate: '轮换 API Key', rotateOk: '旧 Key 进入宽限期（可双 Key 并行），新 Key 只展示一次',
    assignees: '值班人员', addAssignee: '添加值班人', orderInTier: '轮转顺序', removeConfirm: '移除该值班关系？',
    deleteConfirm: '删除该服务？其值班分配与策略将一并删除；已有事件记录的服务不可删除（请改用停用）',
    noAssigneeWarn: '当前层级无人：升级时该层级会被跳过',
    policy: '升级策略', policyGlobal: '全局默认策略', policyService: '本服务覆盖策略', policyHint: '留空/不创建 = 使用全局默认',
    p: {
      readTimeout: '未读转语音超时', ackTimeout: '升级下一层级超时', voiceRetries: '语音呼叫次数',
      voiceInterval: '语音呼叫间隔', adminInterval: '管理员轮呼间隔', adminMaxCycles: '轮呼最大轮数',
      stopOnAnswer: '接听后停止轮呼', stopOnAnswerTip: '值班人接听电话成功即视为已叫醒，取消本层级剩余语音轮呼；升级推进仍以确认接单（批注响应）为准',
    },
    cols: { customer: '所属客户', assignees: '值班人数', status: '状态' },
    savedOk: '已保存',
  },
  customers: {
    title: '客户管理', code: '客户代码', nameCn: '名称（简）', nameTw: '名称（繁）', nameEn: '名称（英）', tz: '默认时区', remark: '备注',
    export: '导出 CSV', import: '导入 CSV', importTitle: '导入客户（CSV）',
    importHint: '表头须包含以下列（仅 code、name_zh_cn 必填），已存在的 code 将被更新：',
    importResult: '导入结果', importStat: '共 {{total}} 行：新建 {{created}}，更新 {{updated}}',
    delConfirm: '确认删除客户 {{code}}？该操作不可恢复',
  },
  categories: { title: '问题类型', code: '类型代码', sort: '排序' },
  users: {
    title: '用户与权限', create: '新建用户', wecom: '企业微信 UserID', password: '登录密码（本地账号）',
    roles: { super_admin: '超级管理员', service_admin: '服务管理员', responder: '值班人员', viewer: '只读审计' },
    roleHint: '角色决定后台权限；值班关系决定可见服务', resetPwd: '重置密码（留空不改）',
    disable: '停用', enable: '启用', deleteConfirm: '确认删除该用户？有历史留痕者会被拒绝',
    disableConfirm: '停用后该用户无法登录/接收值班通知，确定？', enableConfirm: '恢复该用户账号？',
  },
  audit: { apiTitle: '对外 API 调用审计', adminTitle: '管理操作审计', when: '时间', method: '方法', path: '路径', result: '结果', latency: '耗时', ip: '来源 IP', actor: '操作人', actionCol: '动作', target: '对象' },
  settings: {
    title: '系统设置', runtime: '运行环境', wecomMode: '企业微信通道', voiceMode: '语音通道', engine: '升级引擎',
    mockOn: '演示模式（mock）', httpOn: '生产模式（真实 API）', webhookOn: 'Webhook 呼叫平台', off: '关闭',
    base: '服务基地址', defaultPolicy: '默认升级策略', docs: '设计文档位于仓库 docs/ 目录',
    profile: '个人资料', changePassword: '修改密码', currentPwd: '当前密码', newPwd: '新密码（至少 8 位）',
    confirmPwd: '确认新密码', pwdMismatch: '两次输入的新密码不一致',
    relay: {
      title: '语音中继设备', hint: '专用安卓手机安装 Relay App 并填入此处生成的令牌；多台互为备份——同一呼叫仅一台拨出，失败或掉线自动由其他设备接管（至多 3 次尝试）',
      add: '添加设备', hintCol: '令牌', heartbeat: '状态', online: '在线', idle: '宽限中', off: '已停用',
      offlineAlerted: '离线·已告警',
      dials: '累计拨号', rotate: '轮换令牌', rotateConfirm: '轮换后旧令牌立即失效，App 需重新填写，确认？',
      delConfirm: '删除该中继设备？', tokenOnce: '设备令牌（明文仅此一次）',
      tokenOnceHint: '请立即复制到中继手机 App 中保存；本页面无法再次查看。',
      nameExtra: '便于识别的机身位置名称', namePh: '如：前台中继A / 办公室备用机',
    },
  },
  mobile: {
    title: '我的应急事件', empty: '当前没有待处理事件，保持警惕 👀', detail: '事件处理',
    intro: '企业微信免密登录 · 点按即可完成响应', waitingEscalation: '升级链运行中',
    actNow: '立即处理', markRead: '标记已读',
    countdownNote: '超时未响应将自动升级并触发语音电话',
  },
  layout: { collapsed: '收起导航', expand: '展开导航', tzView: '查看时区' },
} as const;

export type I18nSchema = typeof zhCN;
